import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Banner from "./banner-contact/Banner";
const ProjectOverView = dynamic(
  () => import("./project-overview/project-overview"),
  { ssr: true }
);
const BuildSection = dynamic(() => import("./BuildSection"), { ssr: true });
import { useRouter } from "next/navigation";

const CaseNew: React.FC = (props: any) => {
  const blocks = props?.data?.blocks;
  const router = useRouter();
  const [newBlock, setNewBlock] = useState([]);

  useEffect(() => {
    if (!blocks) router.push("/case-studies");
    const relevantComponents = [
      "blocks.case-study-key-points",
      "blocks.key-points",
      "blocks.stack-holder",
      "blocks.casestudy-overview",
      "blocks.technology-tech-stack",
    ];

    const filteredBlocks = blocks?.filter((element: any) => {
      return relevantComponents.includes(element.__component);
    });
    const finalBlock = blocks?.filter((element: any) => {
      return !relevantComponents.includes(element.__component);
    });

    const ProjectOverView1 = {
      __component: "blocks.case-study-key-points",
      keyPoints: filteredBlocks,
    };

    finalBlock?.splice(1, 0, ProjectOverView1);

    setNewBlock(finalBlock);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocks]);

  return (
    <div className="book-new-main">
      {/* <Banner block={props?.data} /> */}
      {newBlock?.length > 0 &&
        newBlock.map((block: any, i: number) => {
          return (
            <React.Fragment key={i}>
              {block.__component === "blocks.about-client" && (
                <>
                  <Banner
                    bannerBlock={props?.data}
                    data={props?.data}
                    block={block}
                  />
                  {/* <CaseStudies data={props?.data} block={block} /> */}
                </>
              )}
              {block.__component === "blocks.case-study-key-points" && (
                <>
                  <ProjectOverView data={block} />
                </>
              )}
              {/* {block.__component === "blocks.related-case-studies" && (
                <RelatedCaseStudies data={block} />
              )} */}

              {block.__component === "blocks.cta" && (
                <BuildSection data={block} />
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default CaseNew;
